<template>
  <div
    id="access_request"
    class="pb-4"
  >
    <!-- 內容頁 -->
    <div
      id="access_requests"
      class="container"
    >
      <div class="row white-color word-bold">
        <!-- 標題 -->
        <div class="col-4 frame5" />
        <div class="col-5 frame6">
          多元繳費系統-人員權限申請表
        </div>
        <div class="col-3 frame4" />
        <!-- 帳號種類 -->
        <div class="col-2 frame2">
          申請權限
        </div>
        <div class="col-10 frame3">
          <div class="form-check form-check-inline ml-2">
            <span
              v-if="prints && ApplyPrivilege === 1"
            >
              系統管理人員(出納人員專用)
            </span>
            <span
              v-if="prints && ApplyPrivilege === 2"
            >
              業務單位管理人員
            </span>
            <input
              v-if="!prints"
              id="unit1"
              class="form-check-input"
              name="account_type"
              type="radio"
              value="2"
              v-model.number="ApplyPrivilege"
            >
            <v-label
              for="unit1"
              class="form-check-label"
              LabText="業務單位管理人員"
              v-if="!prints"
            />
          </div>
          <div class="form-check form-check-inline ml-2">
            <input
              v-if="!prints"
              id="system2"
              class="form-check-input"
              name="account_type"
              type="radio"
              value="1"
              v-model.number="ApplyPrivilege"
            >
            <v-label
              v-if="!prints"
              for="system2"
              class="form-check-label"
              LabText="系統管理人員(出納人員專用)"
            />
          </div>
        </div>
        <!-- 申請類別 -->
        <div class="col-2 frame2">
          申請類別
        </div>
        <div class="col-10 frame3">
          <div class="form-check form-check-inline ml-2">
            <v-label
              v-if="prints"
              class="form-check-label"
              LabText="補印"
            />
            <input
              v-if="!prints"
              id="disable1"
              class="form-check-input"
              name="category"
              type="radio"
              v-model.number="Judge"
              value="1"
            >
            <v-label
              v-if="!prints"
              for="disable1"
              class="form-check-label"
              LabText="申請"
            />
          </div>
          <div class="form-check form-check-inline ml-2">
            <input
              v-if="!prints"
              id="disable3"
              class="form-check-input"
              name="category"
              type="radio"
              v-model.number="Judge"
              value="3"
            >
            <v-label
              v-if="!prints"
              for="disable3"
              class="form-check-label"
              LabText="變更單位"
            />
          </div>
        </div>
        <!-- 前單位名稱 -->
        <div
          v-if="type === 'change'"
          class="col-2 frame2"
        >
          單位名稱
        </div>
        <div
          v-if="type === 'change'"
          class="col-10 frame3"
        >
          <input
            v-if="type === 'change'"
            class="form-control"
            style="text"
            v-model="UserDatas.DeptDesc"
            disabled
          >
        </div>
        <!-- 申請單位 -->
        <div
          id="department"
          class="col-2 frame2"
        >
          申請單位
        </div>
        <div
          id="department2"
          class="col-10 frame3"
        >
          <span
            v-if="prints"
            class="ml-2"
          >
            {{ printDeptName }}
          </span>
          <v-Dept
            v-else
            :DeptData="NewDeptId"
            @SelectDept="SelectDept"
          />
        </div>
        <!-- 申請人員 -->
        <div class="col-2 frame2">
          申請人員
        </div>
        <div class="col-10 frame3">
          <input
            v-if="type === 'change'"
            class="form-control"
            style="text"
            v-model="UserDatas.UserId"
            disabled
          >
          <span
          v-if="type === 'Application'"
          class="ml-2"
          >
            {{ UserData.UserId }}
          </span>
        </div>
        <!-- 姓名 -->
        <div class="col-2 frame2">
          姓名
        </div>
        <div class="col-10 frame3">
          <input
            v-if="type === 'change'"
            class="form-control"
            style="text"
            v-model="UserDatas.UserName"
          >
          <span
            v-if="type === 'Application' && prints"
            class="ml-2"
          >
            {{ UserData.UserName }}
          </span>
          <input
            v-if="type === 'Application' && !prints"
            class="form-control"
            style="text"
            v-model="UserData.UserName"
          >
        </div>
        <!-- Email -->
        <div class="col-2 frame2">
          Email
        </div>
        <div class="col-10 frame3">
          <input
            v-if="type === 'change'"
            class="form-control"
            style="email"
            v-model="UserDatas.Email"
          >
          <span
            v-if="type === 'Application' && prints"
            class="ml-2"
          >
            {{ UserData.Email }}
          </span>
          <input
            v-if="type === 'Application' && !prints"
            class="form-control"
            style="email"
            v-model="UserData.Email"
          >
        </div>
        <!-- Telephone -->
        <div class="col-2 frame2">
          連絡電話
        </div>
        <div class="col-10 frame3">
          <input
            v-if="type === 'change'"
            class="form-control"
            style="text"
            v-model="UserDatas.Telephone"
          >
          <span
            v-if="type === 'Application' && prints"
            class="ml-2"
          >
            {{ UserData.Telephone }}
          </span>
          <input
            v-if="type === 'Application' && !prints"
            class="form-control"
            style="text"
            v-model="UserData.Telephone"
          >
        </div>
        <!-- Address -->
        <div class="col-2 frame2">
          聯絡地址
        </div>
        <div class="col-10 frame3">
          <input
            v-if="type === 'change'"
            class="form-control"
            style="text"
            v-model="UserDatas.Address"
          >
          <span
            v-if="type === 'Application' && prints"
            class="ml-2"
          >
            {{ UserData.Address }}
          </span>
          <input
            v-if="type === 'Application' && !prints"
            class="form-control"
            style="text"
            v-model="UserData.Address"
          >
        </div>
        <!-- 申請人(核章) -->
        <div class="col-3 frame2 signature ar-height">
          申請人(核章)
        </div>
        <div class="col-3 frame3 ar-height" />
        <!-- 單位主管(核章) -->
        <div class="col-3 frame3 signature ar-height">
          單位主管(核章)
        </div>
        <div class="col-3 frame3 ar-height" />
        <!-- 出納組承辦人 -->
        <div class="col-2 frame2 signature ar-height">
          出納組承辦人
        </div>
        <div class="col-2 frame3 ar-height" />
        <!-- 出納組長 -->
        <div class="col-2 frame3 signature ar-height">
          出納組長
        </div>
        <div class="col-2 frame3 ar-height" />
        <!-- 總務長 -->
        <div class="col-2 frame3 signature ar-height">
          總務長
        </div>
        <div class="col-2 frame3 ar-height" />
      </div>
      <br>
    </div>
    <div class="container no-print">
      <span class="small-color spanfss">
        *<span v-if="type !== 'Application'">點擊確認申請後，</span>
        請列印表單，並送至出納組審核。
      </span>
      <br>
      <!-- 功能鈕 -->
      <v-button
        v-if="!prints && !printcheck"
        class="mr-2"
        btn-text="確認申請"
        btn-type="primary"
        @click.native="CheckApply"
      />
      <v-button
        class="mr-2"
        btn-text="列印"
        btn-type="warning"
        v-if="printcheck || type === 'Application'"
        @click.native="print"
      />
      <v-button
        v-if="type === 'Application'"
        class="mr-2"
        btn-text="取消/返回"
        btn-type="secondary"
        @click.native="GoToLogin"
      />
      <v-button
        v-else
        class="mr-2"
        btn-text="取消"
        btn-type="secondary"
        @click.native="GoToReview"
      />
    </div>
  </div>
</template>

<script>
import { apiPrivilegeQuery, apiPrivilegeApply, apiPrivilegeDisable, apiPrivilegeModify } from '../../Api/api'
import vLabel from '@/components/Features/Label'
import $ from 'jquery'
import md5 from 'js-md5'
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    again: {
      type: String,
      default: ''
    }
  },
  components: {
    'v-label': vLabel
  },
  data () {
    return {
      AddUser: '',
      ApplyUserId: '',
      ApplyDeptId: '',
      ApplyPrivilege: 0,
      DeptIdSelect: [],
      ChangeUnit: false,
      UserDatas: {},
      UserData: {},
      Judge: null,
      prints: false,
      printcheck: false,
      printDeptName: '',
      AllDeptData: [],
      NewDeptId: sessionStorage.getItem('SetupDeptID') ? JSON.parse(sessionStorage.getItem('SetupDeptID')) : ''
    }
  },
  mounted () {
    const vm = this
    if (md5('true') === vm.again) {
      const Data = JSON.parse(sessionStorage.getItem('Department'))
      vm.prints = true
      vm.ApplyDeptId = Data.DeptId
      vm.printDeptName = Data.DeptDesc
      vm.ApplyPrivilege = Data.DeptPrivilege
    } else {
      vm.prints = false
    }
    if (vm.type === 'change') { // 判斷變更申請才觸發
      vm.GetUserDatas()
    } else if (vm.type === 'Application') {
      vm.AddPrivilegeUser()
    }
  },
  methods: {
    print () { // 列印
      var text = document
      print(text)
    },
    SelectDept (vDeptId) { // 組件-部門
      this.NewDeptId = vDeptId
      sessionStorage.setItem('SetupDeptID', JSON.stringify(vDeptId))
    },
    AddPrivilegeUser () { // 帳號第一次申請
      // 定義資料
      this.UserData = JSON.parse(sessionStorage.getItem('Userdata'))
    },
    GetUserDatas () { // 帳號變更
      // 定義資料
      const vm = this
      const NewData = JSON.parse(sessionStorage.getItem('Identity'))
      const UserData = JSON.parse(sessionStorage.getItem('UserData'))
      NewData.DeptId = UserData.DeptId
      NewData.QueryUserId = vm.id
      // 呼叫API
      apiPrivilegeQuery(NewData).then(
        res => {
          if (res !== undefined) {
            vm.UserDatas = res.Data[0]
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    CheckApply () { // 判斷申請類別
      const vm = this
      if (vm.Judge === 1) { // 申請單位
        vm.PostPrivilegeApply()
      } else if (vm.Judge === 3) { // 變更單位
        vm.PostPrivilegeModify()
      } else {
        vm.ErrorModal('資料錯誤，請確認申請資料')
      }
    },
    PostPrivilegeApply () { // 申請 B_API 004
      // 定義資料
      const vm = this
      vm.AddUser = ''
      // 判斷使用哪個使用者資料，UserData、UserDatas
      if (vm.UserData.UserId) {
        vm.AddUser = vm.UserData
      } else if (vm.UserDatas.UserId) {
        vm.AddUser = vm.UserDatas
      }
      if (vm.NewDeptId) {
        vm.ApplyDeptId = vm.NewDeptId.DeptId
      }
      const NewData = JSON.parse(sessionStorage.getItem('Identity'))
      NewData.ApplyUserId = vm.AddUser.UserId // 要申請權限的使用者帳號
      NewData.ApplyDeptId = vm.ApplyDeptId // 要申請權限的學校單位代碼
      NewData.ApplyPrivilege = vm.ApplyPrivilege // 要申請的權限類別
      if (vm.AddUser.Telephone === null) {
        NewData.Telephone = ''
      } else {
        NewData.Telephone = vm.AddUser.Telephone
      }
      if (vm.AddUser.Email === null) {
        NewData.Email = ''
      } else {
        NewData.Email = vm.AddUser.Email
      }
      if (vm.AddUser.Address === null) {
        NewData.Address = ''
      } else {
        NewData.Address = vm.AddUser.Address
      }
      if (NewData.ApplyDeptId === '') {
        vm.ErrorModal('請選擇申請單位。')
        return false
      }
      // 呼叫API
      apiPrivilegeApply(NewData).then(
        res => {
          if (res !== undefined) {
            vm.printcheck = true
            vm.$bus.$emit('Modals', '已申請帳號權限，請等待管理員開通')
            $('#CheckOk').modal('show')
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    PostPrivilegeDisable () { // 停用 B_API 006
      // 定義資料
      const vm = this
      const NewData = JSON.parse(sessionStorage.getItem('Identity'))
      NewData.DisableUserId = vm.UserDatas.UserId
      NewData.DisableDeptId = vm.UserDatas.DeptId
      // 呼叫API
      apiPrivilegeDisable(NewData).then(
        res => {
          if (res !== undefined) {
            vm.$bus.$emit('ALogOutCheckUser', 'false')
            vm.$bus.$emit('Modals', '已申請停用')
            $('#CheckOk').modal('show')
            vm.$router.push({ name: 'Admin_Login' })
          } else {
            $('#CheckError').modal('show')
            vm.$bus.$emit('ALogOutCheckUser', 'false')
            vm.$router.push({ name: 'Admin_Login' })
          }
        }
      )
    },
    PostPrivilegeModify () { // 變更 B_API 002
      // 定義資料
      const vm = this
      if (vm.NewDeptId) {
        vm.ApplyDeptId = vm.NewDeptId.DeptId
      } else {
        vm.ErrorModal('請選擇申請單位。')
        return false
      }
      const NewData = JSON.parse(sessionStorage.getItem('Identity'))
      NewData.ModifyUserId = vm.UserDatas.UserId
      NewData.OriDeptId = vm.UserDatas.DeptId
      NewData.ModifyDeptId = vm.ApplyDeptId
      NewData.ModifyUserName = ''
      NewData.ModifyEmail = ''
      NewData.ModifyTelephone = ''
      NewData.ModifyAddress = ''
      NewData.ModifyUnino = ''
      // 呼叫API
      apiPrivilegeModify(NewData).then(
        res => {
          if (res !== undefined) {
            vm.printcheck = true
            vm.$bus.$emit('Modals', '已申請變更單位請登出帳號，待管理者開通權限。')
            $('#CheckOk').modal('show')
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    ErrorModal (data) { // 錯誤彈跳視窗
      this.$bus.$emit('Modals', data)
      $('#CheckError').modal('show')
    },
    GoToLogin () {
      this.$router.push({ name: 'Admin_Login' })
    },
    GoToReview () {
      this.$router.push({ name: 'Admin_UserReview' })
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/applicationform.scss';
  .ar-signature-input {
    height: 73px;
  }
  .ar-height {
    height: 75px;
  }
  input[type="radio"]:checked {
    color: aqua;
  }
</style>
